import fieldOfExperiences from './models/fieldOfExperiences';

export default {
  fieldOfExperiences,
};
